<template>
  <div class="relative bg-white">
    <input
      :id="name"
      :class="[
        { 'bg-grey-4 border-grey-4 cursor-not-allowed': disabled },
        errorMessage
          ? 'border-red-dark enabled:hover:otivo-outline-error enabled:focus:otivo-outline-error enabled:active:otivo-outline-error'
          : 'border-grey-field enabled:hover:otivo-outline enabled:focus:otivo-outline enabled:active:otivo-outline',
      ]"
      :disabled="disabled"
      :max="max"
      :min="min"
      :name="name"
      :value="formattedValue"
      class="rounded-sm px-[15px] py-[10px] border w-full"
      type="date"
      @input="(event: Event) => handleInput(event.target as HTMLInputElement)" />
    <p v-if="errorMessage" class="otivo-error-message absolute right-0">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script lang="ts" setup>
import { lightFormat } from 'date-fns'
import { ref } from 'vue'
import { watchOnce } from '@vueuse/core'

type Props = {
  value: string // Format YYYY-MM-DD
  name: string
  min?: string // Format YYYY-MM-DD
  max?: string // Format YYYY-MM-DD
  errorMessage?: string
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  min: undefined,
  max: lightFormat(new Date(), 'yyyy-MM-dd'),
  errorMessage: undefined,
})

const formattedValue = ref<string>(props.value)

const emits = defineEmits<{ (e: 'update:value', val: string): void }>()

const handleInput = (input: HTMLInputElement) => {
  formattedValue.value = input.value
  emits('update:value', input.value)
}

watchOnce(
  () => props.value,
  () => {
    // Initialize formattedValue with the value prop
    formattedValue.value = props.value
  }
)
</script>
